import {
  DeleteOutlined,
  PlusOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  Divider,
  Input,
  message,
  Popconfirm,
  Row,
  Select,
} from "antd";
import { ReactNode, useState } from "react";
import {
  Add,
  Cancel,
  Delete,
  QuestionRemove,
} from "shared/constants/define-localization";
import { t, CoreResource } from "shared/plugins/localization";
import { cleanUnicode } from "shared/plugins/string-helper";
import {
  ThemeTemplateItem,
  ThemeType,
  ThemeTypeText,
} from "states/theme-template/theme-template.models";
import { ThemeTemplateBasic } from "./theme-template-basic";

export interface IThemeTemplateGroupProps {
  itemKey: string;
  model: ThemeTemplateItem;
  onChange: (changedModel: ThemeTemplateItem) => void;
  onDelete?: () => void;
}

export function ThemeTemplateGroup(props: IThemeTemplateGroupProps) {
  const { itemKey, model, onChange, onDelete } = props;
  const [addItemModel, setAddItemModel] = useState<ThemeTemplateItem>(
    {} as ThemeTemplateItem
  );

  const renderThemeTemplateItems = () => {
    const listItem: any[] = [];

    for (let item in model.value) {
      let templateItem: ReactNode;
      switch (model.value[item].type as ThemeType) {
        case ThemeType.Group:
        case ThemeType.GroupList: {
          templateItem = (
            <>
              <ThemeTemplateGroup
                itemKey={`${itemKey}-${item}`}
                model={model.value[item]}
                onChange={(changedItem) => {
                  model.value[item] = changedItem;
                  onChange(model);
                }}
                onDelete={() => {
                  delete model.value[item];
                  onChange(model);
                }}
              />
              <Divider />
            </>
          );
          break;
        }
        default: {
          templateItem = (
            <>
              <ThemeTemplateBasic
                model={model.value[item]}
                onDelete={() => {
                  delete model.value[item];
                  onChange(model);
                }}
              />
              <Divider />
            </>
          );
          break;
        }
      }
      listItem.push(templateItem);
    }
    return listItem;
  };

  const handleAddThemeTemplateItem = () => {
    if (!addItemModel.name) {
      message.error("Vui lòng nhập tên phần tử");
      return;
    }
    if (addItemModel.type === null || addItemModel.type === undefined) {
      message.error("Vui lòng chọn loại phần tử");
      return;
    }
    const propName = cleanUnicode(addItemModel.name);
    if (model.value[propName]) {
      message.error("Phần tử đã được thêm rồi");
      return;
    }

    model.value[propName] = { ...addItemModel, value: {} };
    onChange(model);
  };

  return (
    <Collapse defaultActiveKey={itemKey} expandIconPosition={`right`}>
      <Collapse.Panel
        key={itemKey}
        header={
          <>
            <b>
              {model.name} - {ThemeTypeText[model.type]}
            </b>{" "}
            {Object.entries(model.value).length === 0 && (
              <span className="text-danger">
                <WarningOutlined /> Vui lòng thêm phần tử
              </span>
            )}
          </>
        }
      >
        <div>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Input
                placeholder="Tên phần tử"
                value={addItemModel.name}
                onChange={(e) => {
                  setAddItemModel({ ...addItemModel, name: e.target.value });
                }}
              />
            </Col>
            <Col span={8}>
              <Select
                value={addItemModel.type}
                className="w-100"
                placeholder={"Loại phần tử"}
                onChange={(e) => {
                  setAddItemModel({ ...addItemModel, type: e });
                }}
                showSearch
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {Object.keys(ThemeType).map((key) =>
                  !isNaN(Number(key)) ? (
                    <Select.Option value={Number(key)}>
                      {ThemeTypeText[Number(key)]}
                    </Select.Option>
                  ) : null
                )}
              </Select>
            </Col>
            <Col span={3}>
              <div className="btn-w d-flex justify-content-between align-items-center flex-auto ">
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={handleAddThemeTemplateItem}
                >
                  {t(CoreResource, Add)}
                </Button>
                {onDelete && (
                  <Popconfirm
                    placement="topLeft"
                    onConfirm={() => {
                      onDelete && onDelete();
                    }}
                    title={"Bạn có muốn xóa không ?"}
                    okText="Đồng ý"
                    cancelText={"Hủy"}
                  >
                    <Button danger icon={<DeleteOutlined />}>
                      Xóa
                    </Button>
                  </Popconfirm>
                )}
              </div>
            </Col>
          </Row>
          <Divider />
          {renderThemeTemplateItems()}
        </div>
      </Collapse.Panel>
    </Collapse>
  );
}
